import
{
    Component,
    OnInit
}
    from '@angular/core';
import
{
    GlobalsService
}
    from 'src/app/globals.service';
import
{
    Router
}
    from '@angular/router';
import
{
    faqListApp,
    faqListDash
}
    from './faq.model';

@Component(
    {
        selector: 'app-faq',
        templateUrl: './faq.component.html',
        styleUrls: ['./faq.component.css']
    })
export class FaqComponent implements OnInit
{
    private faqListApp: any[] = faqListApp;
    private faqListDash: any[] = faqListDash;

    constructor(private globals: GlobalsService, private router: Router)
    { }

    ngOnInit()
    { }

    closeSupport()
    {
        this.router.navigate(['analytics']);
    }
}